import React from "react";
import arrowupimg from '../assets/images/arrow-right-Up-fil.svg';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';
import cities1 from "../assets/images/cities1.png";
import cities2 from "../assets/images/cities2.png";
import cities3 from "../assets/images/cities3.png";
import cities4 from "../assets/images/cities4.png";

const PopularCities = (props) => {

    const cityPackages = [
        { id: 1, title: "Maharashtra", imgUrl: cities1 },
        { id: 2, title: "New Delhi", imgUrl: cities2 },
        { id: 3, title: "Bangalore", imgUrl: cities3 },
        { id: 4, title: "West Bengal", imgUrl: cities4 },

    ];

    return (
        <section className='Travelsection my-5 py-3 Facilities'>
            <div className='row mx-0 text-center Travelsectiontop'>
                <h6>Vrruksh Travels all around the India!</h6>
                <h4>Most Popular Cities We Serve</h4>
                <button className="btnbookprimary m-0 mx-auto d-table mt-2" onClick={() => props?.handleScrollToSection("/", "contact")} style={{ width: "250px" }}>Book your car travel now!</button>
            </div>
            <div className="row mt-5 justify-content-center">
                <div className="col-lg-12 col-md-12">
                    <div className='customerReview m-0'>
                        <Swiper
                            freeMode={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                1024: { slidesPerView: 3.5, spaceBetween: 30 },
                                768: { slidesPerView: 2, spaceBetween: 20 },
                                400: { slidesPerView: 1, spaceBetween: 10 },
                            }}
                            modules={[Autoplay, Navigation, FreeMode]}
                            className="mySwiper"
                        >
                            {cityPackages.map((city) => (
                                <SwiperSlide key={city.id}>
                                    <div className="citiesbox">
                                        <div className="citiesboxtop">
                                            <h6>{city.title}</h6>
                                            <div className="righticoncities">
                                                <img src={arrowupimg} alt="arrow icon" />
                                            </div>
                                        </div>
                                        <img src={city.imgUrl} alt="cities" />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PopularCities;
